import { Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import { Platform, AlertController, IonRouterOutlet } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { AngularFireAuth } from "@angular/fire/auth";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { Connectivity } from "./providers/connectivity-service";
import { ToastController } from "@ionic/angular";

import * as shuffleArray from "shuffle-array";
import { StorageService } from "./services/storage.service";
import {
  LocalNotifications,
  ELocalNotificationTriggerUnit,
} from "@ionic-native/local-notifications/ngx";
import {
  AngularFirestoreDocument,
  AngularFirestore,
} from "@angular/fire/firestore";

// Branch import
declare var Branch;
declare var navigator: any;
declare var Connection: any;
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit {
  //////////////////
  ////Declaration///
  //////////////////
  encourageUsageMessages = [
    `Hey, come use this awesome app again`,
    `Missed you, come back 😭`,
    `Test 3`,
    `Test 4`,
    `Test 5`,
    `Test 6`,
  ];
  showSkip = true;
  lastTimeBackPress = 0;
  timePeriodToExit = 2000;
  feedback: string = "";
  name = "";

  //////////////////
  //Initialization//
  //////////////////

  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;
  firstTime: boolean;
  [x: string]: any;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    public alertController: AlertController,
    private statusBar: StatusBar,
    private router: Router,
    public connectivityService: Connectivity,
    public toastCtrl: ToastController,
    private storageService: StorageService,
    private localNotifications: LocalNotifications,
    private afStore: AngularFirestore
  ) {
    this.backButtonEvent();
    this.initializeApp();
    this.storageService.isFirstTimeLoad();

    // this.review();
    //run the function on the connectivityService to watch the connection status
    this.connectivityService.watchOffline().subscribe(async () => {
      const toast = await this.toastCtrl.create({
        message: "You are offline, lost connection 😢",
        duration: 2000,
      });

      toast.present(); //display toast if connection has been lost
    });

    //cordova code: for back button
    //obtained from https://www.tutorialspoint.com/cordova/cordova_back_button.htm
    // document.addEventListener("backbutton", onBackKeyDown, false);
    // function onBackKeyDown(e) {
    //   // e.preventDefault();
    //   window.history.back();
    // }
  }

  //attempting deep linking
  branchInit = () => {
    if (!this.platform.is("cordova")) {
      return;
    }
    Branch.initSession((data) => {
      console.log("Branch Initialized");
      if (data.$deeplink_path) {
        this.logger.logEvent("deeplink", {});
        console.log("Routing Link" + JSON.stringify(data.$deeplink_path));
        this.routeLink(data.$deeplink_path);
      }
    })
      .then(() => {
        console.log("Branch Init");
      })
      .catch((err) => {
        console.log("Branch Init Error: " + JSON.stringify(err));
      });
  };
  //..

  initializeApp() {
    this.platform.ready().then(async () => {
      this.splashScreen.hide();
      this.statusBar.backgroundColorByHexString("#fff");

      branchInit();
      var networkState = navigator.connection.type;
      var states = {};
      states[Connection.UNKNOWN] =
        "There is an issue with your connection, \nplease ensure you are connected to the internet \nand restart the App.";
      states[Connection.NONE] = "There is no network connection😢";
      const alert = await this.alertController.create({
        header: "Network issue",
        subHeader: states[networkState],
        buttons: ["OK"],
      });

      await alert.present();
    });

    this.platform.resume.subscribe(() => {
      branchInit();
    });

    // Branch initialization
    const branchInit = () => {
      // only on devices
      if (!this.platform.is("cordova")) {
        return;
      }
      Branch.initSession((data) => {
        // read deep link data on click
        // doSomethingWithOurDeeplink(data);
      });
    };
  }

  ngOnInit() {
    //Using this method, diplay encouraging messages to user after a couple of days
    shuffleArray(this.encourageUsageMessages).forEach((message, index) => {
      this.localNotifications.schedule({
        id: index,
        text: message,
        trigger: {
          in: 1 + index * 2, //index * 2, //
          unit: ELocalNotificationTriggerUnit.DAY,
        },
      });
    });
  }

  backButtonEvent() {
    this.platform.backButton.subscribeWithPriority(0, () => {
      this.routerOutlets.forEach(async (outlet: IonRouterOutlet) => {
        if (this.router.url != "/home") {
          // await this.router.navigate(['/']);
          window.history.back();
        } else if (this.router.url === "/home") {
          if (
            new Date().getTime() - this.lastTimeBackPress >=
            this.timePeriodToExit
          ) {
            this.lastTimeBackPress = new Date().getTime();
            this.presentAlertConfirm();
          } else {
            navigator["app"].exitApp();
          }
        }
      });
    });
  }

  async presentAlertConfirm() {
    const alert = await this.alertController.create({
      // header: 'Confirm!',
      message: "Are you sure you want to exit the app?",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {
            this.review();
          },
        },
        {
          text: "Close App",
          handler: () => {
            this.review();
            navigator["app"].exitApp();
          },
        },
      ],
    });

    await alert.present();
  }

  async review() {
    var username = window.localStorage.getItem("name");
    const review: AngularFirestoreDocument<any> = this.afStore.doc(
      `review/${username}`
    );
    const message = this.toastCtrl.create({
      message: "Thank you for the feedback 💕 from your TAG team",
      duration: 1500,
    });

    const alert = await this.alertController.create({
      header: "Feedback",
      message: "How did we do?",
      cssClass: "buttons",
      inputs: [
        {
          name: "name",
          placeholder: "Please leave a review",
        },
      ],
      buttons: [
        {
          text: "☹",
          handler: (data) => {
            // JSON.stringify(data);
            this.name = JSON.stringify(data.name);
            this.feedback = "worst";

            return review
              .set({
                feedback: this.feedback,
                message: this.name,
                user: username,
              })
              .then(async () => {
                (await message).present();
              });
          },
        },
        {
          text: "🙁",
          handler: (data) => {
            // JSON.stringify(data);
            this.name = JSON.stringify(data.name);
            this.feedback = "not_good";

            return review
              .set({
                feedback: this.feedback,
                message: this.name,
                user: username,
              })
              .then(async () => {
                (await message).present();
              });
          },
        },
        {
          text: "😐",
          handler: (data) => {
            // JSON.stringify(data);
            this.name = JSON.stringify(data.name);
            this.feedback = "neutral";

            return review
              .set({
                feedback: this.feedback,
                message: this.name,
                user: username,
              })
              .then(async () => {
                (await message).present();
              });
          },
        },
        {
          text: "🙂",
          handler: (data) => {
            // JSON.stringify(data);
            this.name = JSON.stringify(data.name);
            this.feedback = "good";

            return review
              .set({
                feedback: this.feedback,
                message: this.name,
                user: username,
              })
              .then(async () => {
                (await message).present();
              });
          },
        },
        {
          text: "😁",
          handler: (data) => {
            // JSON.stringify(data);
            this.name = JSON.stringify(data.name);
            this.feedback = "excellent";

            return review
              .set({
                feedback: this.feedback,
                message: this.name,
                user: username,
              })
              .then(async () => {
                (await message).present();
              });
          },
        },
      ],
    });
    await alert.present();
  }
}
